{
  "actionbar.actions": "Acțiuni",
  "actionbar.actionsAvailable": "Acțiuni disponibile.",
  "actionbar.clearSelection": "Goliți selecția",
  "actionbar.selected": "{count, plural, =0 {Niciunul selectat} other {# selectate}}",
  "actionbar.selectedAll": "Toate elementele selectate",
  "breadcrumbs.more": "Mai multe articole",
  "button.pending": "în așteptare",
  "combobox.noResults": "Niciun rezultat",
  "contextualhelp.help": "Ajutor",
  "contextualhelp.info": "Informații",
  "dialog.alert": "Alertă",
  "dialog.dismiss": "Revocare",
  "dropzone.replaceMessage": "Plasați fișierul pentru a înlocui",
  "inlinealert.informative": "Informații",
  "inlinealert.negative": "Eroare",
  "inlinealert.notice": "Avertisment",
  "inlinealert.positive": "Succes",
  "label.(optional)": "(opţional)",
  "label.(required)": "(obligatoriu)",
  "menu.moreActions": "Mai multe acțiuni",
  "notificationbadge.indicatorOnly": "Activitate nouă",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Selectați…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Se încarcă...",
  "table.loadingMore": "Se încarcă mai multe...",
  "table.resizeColumn": "Redimensionați coloana",
  "table.sortAscending": "Sortați crescător",
  "table.sortDescending": "Sortați descrescător",
  "tag.actions": "Acțiuni",
  "tag.hideButtonLabel": "Se afișează mai puțin",
  "tag.noTags": "Niciuna",
  "tag.showAllButtonLabel": "Se afișează tot ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
